<template>
    <v-dialog
        v-bind="$attrs"
        v-on="$listeners"
        v-model="computedValue"
        :lazy="defaultAttrs.lazy"
        :persistent="defaultAttrs.persistent"
        :scrollable="defaultAttrs.scrollable"
        :max-width="defaultAttrs.maxWidth"
        :fullscreen="defaultAttrs.fullscreen"
    >
        <slot></slot>
    </v-dialog>
</template>

<script>
export default {
    props: ["value"],
    computed: {
        computedValue: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit("input", val);
            },
        },
        defaultAttrs() {
            return {
                maxWidth: this.$attrs["max-width"] ? this.$attrs["max-width"] : "500",
                lazy: typeof this.$attrs["lazy"] != "undefined" ? this.$attrs["lazy"] : true,
                persistent: typeof this.$attrs["persistent"] != "undefined" ? this.$attrs["persistent"] : true,
                scrollable: typeof this.$attrs["scrollable"] != "undefined" ? this.$attrs["scrollable"] : true,
                fullscreen: typeof this.$attrs["fullscreen"] != "undefined" ? this.$attrs["fullscreen"] : this.$bp.smallScreen,
            };
        },
    },
};
</script>
